var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer kt-grid__item bgi-position-center-center bgi-size-cover bgi-no-cover",staticStyle:{"background-image":"url('media/bg/bg-2.jpg')"},attrs:{"id":"kt_footer"}})}
var staticRenderFns = []

export { render, staticRenderFns }